import React from "react";

import { type SwitchProps as RadixProps, Root, Thumb } from "@radix-ui/react-switch";
import cx from "classnames";
import type { Placement } from "tippy.js";

import { Tooltip } from "~/ui";

import styles from "./Switch.module.css";

export interface SwitchProps extends Omit<RadixProps, "asChild"> {
	size?: "tiny" | "small" | "medium";
	disabledTooltip?: string;
	tooltipPlacement?: Placement;
}

const Switch = ({ className, size = "medium", disabledTooltip, tooltipPlacement, ...rest }: SwitchProps) => {
	// The wrapper is required since Tippy and the Switch don't play nice when it's disabled
	const content = (
		<div className={styles.wrapper}>
			<Root className={cx(styles.root, className, styles[size])} {...rest}>
				<Thumb className={styles.thumb} />
			</Root>
		</div>
	);

	if (rest.disabled && disabledTooltip) {
		return (
			<Tooltip
				placement={tooltipPlacement ?? "left"}
				maxWidth={220}
				content={<div style={{ textAlign: "center" }}>{disabledTooltip}</div>}
			>
				{content}
			</Tooltip>
		);
	}
	return content;
};

export default Switch;
